import { Injectable } from '@angular/core';
import { AppAuthHttpService } from '../../../http/app.auth.http.service';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';
import { ResponseUtilService } from '../../../shared/utils/response-util.service';
import { Observable } from 'rxjs/Observable';
import { Property } from '../../models/property';
import { Headers, RequestOptions } from '@angular/http';

@Injectable()
export class PropertyHttpService {
  private eventsGetUrl: string = this.environment.baseUrl + '/api/property';
  private eventsAddUrl: string = this.environment.baseUrl + '/api/property';

  constructor(private http: AppAuthHttpService,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService) {
  }

  private get jsonOptions(): RequestOptions {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    return options;
  }

  get(propertyId: number): Observable<Property> {
    return this.http.get(`${this.eventsGetUrl}/${propertyId}`)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  add(newRec: Property): Observable<Property> {
    return this.http.post(this.eventsAddUrl, JSON.stringify(newRec.toJS()), this.jsonOptions)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/property/property.http.service.ts